import { apiSlice } from "../api/apiSlice";
import io from "socket.io-client";
export const teamsApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getTeams: builder.query({
            query: (id) =>`/teams?members_like=${id}&_sort=created&_order=desc`,
            providesTags: ['Teams'],
        }),


        addTeam: builder.mutation({
            query: ({id,data}) => ({
                url: "/teams",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Teams"],
        }),
        
        addTeamMembers: builder.mutation({
            query: ({id,data}) => ({
                url: `/teams/${id}`,
                method: "PATCH",
                body: data,
            }),
            invalidatesTags: ["Teams"],
        }),
    }),
});

export const { useGetTeamsQuery, useAddTeamMutation, useAddTeamMembersMutation } = teamsApi;
